import React, { useEffect } from "react";
import { RegisterForm } from "@hedgefund/shared";
import { isCooperativeEmailAction, signUpAction } from "./actions";
// import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { isCompanyNameExistAction, isEmailExistAction } from "./actions";
import { getInvestorType } from "../../UpdateUser/actions";
import debounce from "lodash/debounce";
import SignUpSuccess from "@hedgefund/shared/src/SignUpSuccess";

const SignUp = () => {
  // const history = useHistory();
  const investorTypeState = useSelector(
    (state) => state.userDetails.getInvestors
  );
  const signUpState = useSelector((state) => state.signup);

  const { loading, isCompanyNameExist, isEmailExist, signUpSuccess, isCompanyCooperativeEmail } =
    signUpState;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getInvestorType());
  }, [dispatch]);

  const onSuccess = () => {
    // history.push("/");
  };

  const handleSubmit = (data) => {
    dispatch(signUpAction(data, onSuccess));
  };
  const handleChangeCompanyName = debounce(
    (isCompanyNameExist, onChangeSuccess) => {
      dispatch(isCompanyNameExistAction(isCompanyNameExist, onChangeSuccess));
    },
    1500
  );

  const handleChangeEmailAddress = debounce((isEmailExist, onChangeSuccess) => {
    dispatch(isEmailExistAction(isEmailExist, onChangeSuccess));
  }, 1500);

  const handleCooperativeEmailAddress = debounce((isEmailExist, onChangeSuccess) => {
    dispatch(isCooperativeEmailAction(isEmailExist, onChangeSuccess));
  }, 1500);

  return (
    <>
      {signUpSuccess ? (
        <SignUpSuccess heading="Allocator Sign Up" text="Thank you for registering for the FCN Platform! Your account is currently pending and will be reviewed by the FCN team. When approved, you will receive a confirmation email. Until then, your login and password will not be active. Thank you for joining the FCN Platform!" />
      ) : (
        <RegisterForm
          loading={loading}
          onSubmitSignUpHandler={handleSubmit}
          investorTypeData={investorTypeState}
          handleChangeCompanyName={handleChangeCompanyName}
          handleChangeEmailAddress={handleChangeEmailAddress}
          isCompanyNameExist={isCompanyNameExist}
          handleCooperativeEmailAddress= {handleCooperativeEmailAddress}
          isCompanyCooperativeEmail={isCompanyCooperativeEmail}
          isEmailExist={isEmailExist}
          title="Allocator"
        />
      )}
    </>
  );
};

export default SignUp;
